import { CURRENCY_CODE } from "./constants";
import itemDataTemplate from "./itemDataTemplate";

const ecommerceDataTemplate = ({
  productId,
  productCode,
  variantId,
  brand,
  colour,
  title,
  price,
  variants
}) => {
  const { currency, xrp, current } = { ...price };

  const ecommerceData = {
    currency: CURRENCY_CODE,
    localCurrencyCode: currency,
    valueLocalCurrency: current.value,
    items: [
      itemDataTemplate({
        productId,
        productCode,
        variantId,
        brand,
        colour,
        title,
        price,
        variants
      })
    ]
  };

  ecommerceData.value = xrp?.value || undefined;

  return ecommerceData;
};

export default ecommerceDataTemplate;
